<template>
	<div id="leading-enterprises">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox ">
					<div class="enterparise_guide">
						<div class="w95mg">
							<div class="s_screen_choose">
								<span class="span-screen">{{notionname}}</span>
							</div>
							<!-- <p class="fr">产业招商大脑为您找到<span class="searchnum">{{total}}</span>条匹配的{{typefont}}</p> -->
							<p class="fr">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						</div>
					</div>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<!-- 龙头企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-if="pagetype == 0 || pagetype == 1 || pagetype == 3 || pagetype == 9 ">
							<tr>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>投资数</th>
								<th>员工人数</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td class="title" @click="detailrouterto('/enterprises',list.stockCode,pagetype)">
									{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',pagetype,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',pagetype,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td v-html="list.invest == 50?'50+':list.invest"></td>
								<td>{{list.insurePerson}}</td>
							</tr>
						</table>
						<!-- 创新企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 2 ">
							<tr>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<!-- <th>星级</th> -->
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>地区</th>
								<th>投资方</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td class="title" @click="detailrouterto('enterprises',list.stockCode,pagetype)">
									{{list.title}}</td>
								<td class="conpanytags hastag1" v-show="list.notion!=''">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',pagetype,'notion',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td class="conpanytags hastag1" v-show="list.tag!=''">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',pagetype,'tag',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td> 
								<td v-html="list.financingRound.length>0?list.financingRound[0].rount:'-'"></td>
								<td v-html="list.financingRound.length>0?list.financingRound[0].time:'-'"></td>
								<td v-html="list.financingRound.length>0?list.financingRound[0].amount:'-'"></td>
								<td>{{list.area}}</td>
								<td class="orglist">
									<p v-if="list.financingRound.length>0"><span :key="inds"
											v-for="(org,inds) in list.financingRound[0].orgList" data="org.id"
											:class="org.id!=0?'curp':''"
											@click="routerlinkid('/investement-enterprises',org.id)">
											{{org.orgName}}<i
												v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span></p>
									<p v-if="list.financingRound.length==0">-</p>
								</td>
							</tr>
						</table>
						<!--投资机构所投资的该领域企业  -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 8 && enterprise_id">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th> 
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>地区</th>
								<th>投资方</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td>{{i+1}}</td>
								<td class="title" @click="detailrouterto('enterprises',list.stockCode,pagetype)">
									{{list.title}}</td>
								<td class="conpanytags hastag1" v-show="list.notion!=''">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',pagetype,'notion',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td class="conpanytags hastag1" v-show="list.tag!=''">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',pagetype,'tag',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td>{{list.rount}}</td>
								<td>{{list.time}}</td>
								<td>{{list.amount}}</td>
								<td>{{list.area}}</td>
								<td class="orglist">
									<p>
										<span :key="inds" v-for="(org,inds) in list.orgList" data="org.id" :class="org.id!=0?'curp':''"
											@click="routerlinkid('/investement-enterprises',org.id)"><i v-if="inds>0">、</i>{{org.orgName}}</span></p>
									<p v-if="list.orgList.length==0">-</p>
								</td>
							</tr>
						</table>
						<!-- 研究机构 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 7">
							<tr>
								<th>企业名称 </th>
								<th>地区</th>
								<th>员工人数</th>
								<th>研究领域</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td class="title" @click="detailrouterto('/resources-enterprises',list.id,list.title)">
									{{list.title}}</td>
								<td>{{list.area}}</td>
								<td>{{list.insurePerson}}</td>
								<td :class="list.notion == ''?'conpanytags':'conpanytags hastag'">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',pagetype,'notion',item.id,item.name)">{{item.name}}</span>
									<i v-show="list.notionlist.length==0" style="color:#999">-</i>
								</td>
							</tr>
							</tr>
						</table>
						<!-- 投资机构公司列表 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 6">
							<tr>
								<th>企业名称 </th>
								<th>投资领域</th>
								<th>画像标签</th>
								<th>项目数</th>
								<th>进入下一轮项目数</th>
								<!-- <th>投资阶段</th> -->
								<th>机构类型</th>
								<th>地区</th>
								<th>管理规模 </th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td class="title" @click="detailrouterto('/investement-enterprises',list.id,pagetype)">
									{{list.name}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',pagetype,'notion',item.id,item.name)">{{item.name}}</span>
									<i v-if="list.notion == ''">-</i>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',pagetype,'tag',item.id,item.name)">{{item.name}}</span>
									<i v-if="list.tag == ''">-</i>
								</td>
								<td>{{list.projectCount}}</td>
								<td>{{list.nextRound}}</td>
								<!-- <td>{{list.stage}}</td> -->
								<td>{{list.type}}</td>
								<td>{{list.area}}</td>
								<td>
									<span v-if="list.asset != ''">{{list.asset}}</span>
									<span v-if="list.asset == ''">-</span>
								</td>
							</tr>
						</table>
						<!-- 优质企业 -->
						<!-- 	<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 4">
						<tr><th>企业名称</th><th>所属产业</th><th>画像标签</th><th>地区</th><th>投资数</th><th>员工人数</th></tr> 
						<tr :key="i"  v-for="(list,i) in enterpristlist">
							<td class="title"  @click="detailrouterto('/enterprises',list.stockCode,2)" >{{list.title}}</td>
							<td class="conpanytags hastag">
								<span class="span-tag"  :key="index"  v-for="(item,index) in list.notionlist"  @click="tagrouter('/enterpriseTag',pagetype,'notion',item.id,item.name,'quality3')">{{item.name}}</span> 
							</td>
							<td class="conpanytags hastag"> 
								<span class="span-tag"  :key="index"  v-for="(item,index) in list.taglist" @click="tagrouter('/enterpriseTag',pagetype,'tag',item.id,item.name,'quality3')">{{item.name}}</span> 
							</td>
							<td>{{list.area}}</td>     
							<td v-html="list.invest == 50?'50+':list.invest"></td>  
							<td>{{list.insurePerson}}</td>  
						</tr>
					</table> -->
						<!-- 全库 -->
						<!-- <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 0">  
						<tr><th>企业名称</th><th>所属产业</th><th>画像标签</th><th>地区</th><th>投资数</th><th>员工人数</th></tr> 
						<tr :key="i"  v-for="(list,i) in enterpristlist">
							<td class="title"  @click="detailrouterto('/enterprises',list.stockCode,2)" >{{list.title}}</td>
							<td class="conpanytags hastag">
								<span class="span-tag"  :key="index"  v-for="(item,index) in list.notionlist"  @click="tagrouter('/enterpriseTag',1,'notion',item.id,item.name,'all')">{{item.name}}</span> 
							</td>
							<td class="conpanytags hastag"> 
								<span class="span-tag"  :key="index"  v-for="(item,index) in list.taglist" @click="tagrouter('/enterpriseTag',1,'tag',item.id,item.name,'all')">{{item.name}}</span> 
							</td>
							<td>{{list.area}}</td>     
							<td v-html="list.invest == 50?'50+':list.invest"></td>  
							<td>{{list.insurePerson}}</td>  
						</tr>
					</table> -->
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
		<footerbar v-if="userdata.userType>1"></footerbar>
	</div>
</template>
<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	import $ from "jquery";
	export default {
		name: 'enterpriseTag',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				enterprise_id: 0, //机构详情页跳转自带企业id
				msg: "标签筛选页",
				page: 1, //显示的是哪一页
				pagetype: 2,
				enterinarr: [{
						curindex: 1,
						type: 9,
						name: "上市公司",
					},
					{
						curindex: 2,
						type: 1,
						name: "龙头企业",
					},
					{
						curindex: 3,
						type: 2,
						name: "创新企业",
					},
					{
						curindex: 4,
						type: 3,
						name: "优质企业",
					},
					{
						curindex: 5,
						type: 0,
						name: "全部企业",
					},
					{
						curindex: 6,
						type: 6,
						name: "投资机构",
					},
					{
						curindex: 7,
						type: 7,
						name: "科研机构",
					},
					{
						curindex: 8,
						type: 8,
						name: "投资机构所投资的该领域企业",
					},
				],
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数  
				enterpristlist: [],
				num: 1,
				testtoken: "-d8d2de4bc22ab997e946f42f9d49b79b",
				notionname: "标签",
				typefont: '龙头企业',
				userdata: {},
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', false);
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var that = this;
			this.userdata = this.getuseriformation();
			this.tagid = this.$route.query.id;
			this.pagetype = this.$route.query.type;
			this.key = this.$route.query.key;
			this.notionname = this.$route.query.keyword;
			this.enterprise_id = this.$route.query.eid;
			// if(this.pagetype == 1){this.typefont = '龙头企业'};
			// if(this.pagetype == 'all' || this.pagetype == 0){this.pagetype=0;this.typefont = '全部企业'};
			// if(this.pagetype == 2){this.typefont = '新兴企业'};
			// if(this.pagetype == 6){this.typefont = '研究院'}; //研究院就是创新资源
			// if(this.pagetype == 5){this.typefont = '投资机构'};  
			// if(this.pagetype == 4){this.typefont = '优质企业'};
			// if(this.pagetype == 9){this.typefont = '上市企业'};
			for (var i = 0; i < this.enterinarr.length; i++) {
				if (this.enterinarr[i].type == that.pagetype) {
					that.typefont = that.enterinarr[i].name;
					that.curindex = that.enterinarr[i].curindex;
				}
			}
		},
		mounted() {
			this.userdata = this.getuseriformation();
			var that = this;
			this.pageHandler(1);
			if (this.key == 'tag') {
				document.title = this.notionname + '-' + '标签搜索';
			} else {
				document.title = this.notionname + '-' + '产业搜索';
			}

		},

		methods: {
			detailrouterto(path, id, type) {
				let routeUrl = this.$router.resolve({
					path: path,
					query: {
						type: type,
						id: id
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			pageHandler: function(page) {
				this.getEnterpriseList(page);
			},
			getEnterpriseList(pages) {
				this.bus.$emit('loading', true);
				var ajaxurl = "";
				var pagestype = this.pagetype;
				this.page = pages ? pages : 1;
				var tagjson = "&" + this.key + '=' + this.tagid;
				if (pagestype == 1 || pagestype == 2 || pagestype == 3 || pagestype == 9 || pagestype == 0) {
					ajaxurl = this.$api.cyl.enterprise.list() + '?type=' + pagestype + tagjson + '&page=' + this.page; 
				} else if (this.pagetype == 6) {
					ajaxurl = this.$api.cyl.investorg.list() + "?province=0" + tagjson + '&page=' + pages;
				} else if (this.pagetype == 7) {
					ajaxurl = this.$api.cyl.academy.list() + "?province=0" + tagjson + '&page=' + pages;
				}else if(pagestype == 8){ 
						ajaxurl=this.$api.cyl.investorg.enterpriseList()+'?id='+this.enterprise_id+'&resultType=1&notionCode='+this.tagid; 
				}
				console.log(ajaxurl);
				var that = this;
				console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(res.data)  
					console.log(ajaxurl,res.data);
					if (res.data.success) { 
						that.enterpristlist = res.data.list;  
						for (var i = 0; i < res.data.list.length; i++) {
							that.enterpristlist[i].notionlist = that.taglistfun(that.enterpristlist[i].notion,
							that.enterpristlist[i].notionCode, 'notionsort');
							that.enterpristlist[i].taglist = that.taglistfun(that.enterpristlist[i].tag, that.enterpristlist[i].tagCode);
							//创新企业专属
							if (that.pagestype == 2 && that.enterpristlist[i].financingRound == null) {
								that.enterpristlist[i].financingRound = [];
							}
						}
						that.bus.$emit('loading', false);
						that.totalPage = res.data.totalPage;
						that.pageSize = res.data.pageSize; 
						that.total = pagestype == 8 ? res.data.list.length: res.data.totalRecord;
						that.haspage = res.data.list.length == res.data.pageSize;
					} else {

					}
				})
			}
		},
	}
</script>

<style type="text/css" scoped="scoped">
	@import "../../assets/css/zpageNav.css";
</style>